import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { ISSUE_FIELD_DATETIME_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggConnectDateTimeToLegacyField: FieldTransformer = (node) => ({
	...transformAggNodeToLegacyField(node),
	value: node.dateTime ?? null,
	schema: {
		configuration: null,
		items: null,
		renderer: PLAIN_TEXT,
		system: null,
		custom: node.type,
		type: ISSUE_FIELD_DATETIME_CF_TYPE,
	},
});
